import React from "react";
import { EntryType } from "@/types";
import { getEntryTypes } from "./utils";
import { cn } from "@/lib/utils";

interface EntryTypeSelectorProps {
  selectedType: EntryType | null;
  onSelectType: (type: EntryType) => void;
}

const EntryTypeSelector: React.FC<EntryTypeSelectorProps> = ({
  selectedType,
  onSelectType,
}) => {
  const entryTypes = getEntryTypes();

  return (
    <div className="w-full px-4 pb-6">
      <div className="grid grid-cols-3 gap-3 w-full">
        {entryTypes.map((entry) => {
          const isSelected = selectedType === entry.type;
          return (
            <button
              key={entry.type}
              type="button"
              onClick={() => onSelectType(entry.type)}
              className={cn(
                "flex flex-col items-center justify-center gap-2 p-3 rounded-xl border bg-white shadow-xs transition-all",
                isSelected
                  ? "border-brand-300 bg-brand-50 shadow-sm"
                  : "border-gray-200 hover:border-brand-200 hover:bg-brand-25",
              )}
            >
              <div
                className={cn(
                  "flex h-10 w-10 items-center justify-center rounded-lg border",
                  isSelected
                    ? "border-brand-200 bg-brand-100 text-brand-600"
                    : "border-gray-200 bg-gray-50 text-gray-500",
                )}
              >
                <entry.icon className="h-5 w-5" />
              </div>
              <span
                className={cn(
                  "text-[11px] font-semibold text-center leading-tight",
                  isSelected ? "text-brand-700" : "text-gray-600",
                )}
              >
                {entry.label}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default EntryTypeSelector;
